var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerOutlineMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    },
    d: "M406.3,321 C431,270,429,209,406,157c-14-32-37-58-68-79c-5-3-10-6-15-9c-6-3-12-6-19-9c-22-8-45-14-68-13c-2,0-4,2-4,4c0,28,0,56,0,84"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    },
    d: "M88.9,111 C64,138,49,171,42,208c-6,34-2,67,10,99c25,67,88,115,159,123c43,5,85-5,121.1-27"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.4,261.6l-79-113c-2.6-3.7-1.7-8.7,2-11.3c2.8-2,6.5-2,9.3,0l113,79c14.6,10.5,17.9,30.8,7.4,45.4 c-10.3,14.3-30.1,17.8-44.6,7.9C214.3,267.4,211.6,264.7,209.4,261.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373,261c-58.7,0-106.4,47.7-106.4,106.4S314.3,473.8,373,473.8s106.4-47.7,106.4-106.4S431.7,261,373,261z M413.9,375.6 h-81.9c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2h81.9c4.5,0,8.2,3.7,8.2,8.2S418.5,375.6,413.9,375.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerOutlineMinus);
export default __webpack_public_path__ + "static/media/timer-outline-minus.8563cbbef6fbc53eeb9c58c7eabe4fe2.svg";
export { ForwardRef as ReactComponent };